import Button from '@frontend/jetlend-web-ui/src/ui/inputs/Button/Button';
import React, { useCallback } from 'react';
import {
    useWindowSize,
    isMobile,
} from '@frontend/jetlend-web-ui/src/utils/responsive';
import { getAssetSrc } from '@frontend/jetlend-web-ui/src/utils/getAssetSrc';
import { useRouter } from 'next/navigation';
import FormAchievements from '@app/components/FormAchievements/FormAchievements';
import JivoChatMobileAnimation from '@app/components/JivoChatMobileAnimation/JivoChatMobileAnimation';
import HtmlMarkup from '@app/components/HtmlMarkup/HtmlMarkup';
import Section from '@app/ui/Section/Section';
import { BaseSectionWithBlocks } from '@app/models/common/common';
import TopLoginPlate from '@app/components/TopLoginPlate/TopLoginPlate';
import { getCurrentHref } from '@app/hooks/common/useQueryParams';
import styles from './BannerSection.module.scss';
import Image from '@app/components/Image/Image';
import { IFeatureBlockApiModel } from '@app/models/sections/features';

export interface IProps {
    /**
     * Заголовок банера
     */
    title: string;
    /**
     * Описание банера
     */
    description: string;
    /**
     * Ссылка на фоновую картинку банера
     */
    imageUrl: string;
    /**
     * Текст alt тега картинки баннера
     */
    imageAlt: string;
    /**
     * Доп. поля с информацией о академии
     */
    blocks: BaseSectionWithBlocks<IFeatureBlockApiModel>[];
}

/**
 * Компонент отрисовки банера на главной странице академии
 */
export default function BannerSection({
    title,
    description,
    imageUrl,
    imageAlt,
    blocks,
}: IProps) {
    const statistics = blocks?.find(item => item.type === 'statistics');
    const router = useRouter();
    const { width } = useWindowSize();
    const isMobileScreen = isMobile(width);

    const didButtonClicked = useCallback(() => {
        const href = getCurrentHref()?.href;
        router.replace(`${href}courses`, { scroll: false });
    }, [router]);

    return (
        <>
            <TopLoginPlate />
            <JivoChatMobileAnimation />
            <div className={styles['desktop-view']}>
                <Image className={styles['banner-image']} src={getAssetSrc(imageUrl)} alt={imageAlt ?? ''} fill />
                <Section
                    animation="none"
                    filled={false}
                >
                    <div className={styles['container']}>
                        <div className={styles['form']}>
                            <HtmlMarkup tag="h1" className={styles['form__heading']} markup={title} />
                            <div className={styles['form__subsection']}>
                                <HtmlMarkup tag="p" className={styles['form__description']} markup={description} />
                            </div>
                            <div className={styles['academy-block']}>
                                {statistics?.blocks?.map(item => (
                                    <div key={item?.title}>
                                        <div className={styles['academy-item-value']}>{item?.value}</div>
                                        <div className={styles['academy-item-title']}>{item?.title}</div>
                                    </div>
                                ))}
                            </div>
                            <Button
                                block={isMobileScreen}
                                containerClassName={styles['academy-button']}
                                size={isMobileScreen ? 'normal' : 'big'}
                                text="Начать обучение"
                                buttonType="button"
                                onClick={didButtonClicked}
                            />
                        </div>
                        <FormAchievements className={styles['achievements']} />
                    </div>
                </Section>
            </div>
        </>
    );
}
